export default "__VITE_ASSET__DILf0DIU__"